import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 班级的课堂行为统计
  behaviorStat(params) {
    return http.post(URL.API_BEHAVIOR_STAT, params)
  },
  // 分页查询课堂行为列表
  pageBehavior(params) {
    return http.post(URL.API_BEHAVIOR_LIST, params)
  },
  // 导出课堂行为统计报表（通过工作通知发送给操作人员）
  exportBehaviorStat(params) {
    return http.post(URL.API_BEHAVIOR_EXPORT, params)
  }
}
